import { BlameLogRefType, BlameLogType, } from '@debbie/common/dist/blamelog/index.js';
import keys from '@debbie/common/dist/cache/keys.js';
import { Entity } from '@debbie/common/dist/index.js';
import { UpdateState } from '@debbie/common/dist/updates/index.js';
import { useMutation } from '@debbie/common/dist/util/hooks.js';
import { blameLogs } from '@debbie/cortex/dist/api/index.js';
import * as workflowsAPI from '@debbie/cortex/dist/api/workflows.js';
import { caseVouchersEntity } from '@debbie/cortex/dist/case-vouchers/index.js';
import { casesEntity, ensureCaseLoaded, } from '@debbie/cortex/dist/cases/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import { interactionsByReferenceKey } from '@debbie/cortex/dist/interactions/index.js';
import q from '@debbie/cortex/dist/query.js';
import { useUpdateTypesMap } from '@debbie/cortex/dist/update-types/index.js';
import { ensureUpdatesLoadedByRef, updatesEntity, } from '@debbie/cortex/dist/updates/index.js';
import React from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import { errorNotification } from '../../utils/errors.js';
import { Button, Panel } from '../index.js';
const NodeEditorWithCaseContext = (props) => {
    const updateTypesMapLoadable = useUpdateTypesMap();
    const updateTypesMap = h.hasData(updateTypesMapLoadable)
        ? updateTypesMapLoadable.data
        : {};
    const lang = useSelector((s) => s.lang);
    const { node } = props;
    const rollbackMutation = useMutation(async (updateId) => {
        await workflowsAPI.rollback(props.caseContext.singleCase.caseId, updateId);
        const blameLog = {
            details: {
                label: executedUpdate?.label,
                workflowTitle: props.workflow.title,
            },
            refId: props.caseContext.singleCase.caseId,
            refType: BlameLogRefType.Case,
            type: BlameLogType.WorkflowRollback,
        };
        await blameLogs.createBlameLog(blameLog, props.caseContext.singleCase.tenantId);
        q.invalidate(keys.write.modify(updatesEntity, ''));
        q.invalidate(keys.write.modify(casesEntity, props.caseContext.singleCase.caseId));
        q.invalidate(keys.write.modify(caseVouchersEntity, ''));
        q.invalidate([
            interactionsByReferenceKey(Entity.Case, props.caseContext.singleCase.caseId),
        ]);
        await ensureUpdatesLoadedByRef(props.caseContext.singleCase.caseId);
        await ensureCaseLoaded(props.caseContext.singleCase.caseId);
    }, {
        onSuccess: () => {
            props.closeModal();
        },
        onError: (err) => {
            errorNotification(lang, err, 'any', lang.errorEntities.rollbackTask);
        },
    });
    const runTaskMutation = useMutation(async () => {
        await workflowsAPI.runTask(props.workflow.workflowId, props.caseContext.singleCase.caseId, node.id);
        q.invalidate(keys.write.modify(updatesEntity, ''));
        q.invalidate(keys.write.modify(casesEntity, props.caseContext.singleCase.caseId));
        q.invalidate(keys.write.modify(caseVouchersEntity, ''));
        q.invalidate([
            interactionsByReferenceKey(Entity.Case, props.caseContext.singleCase.caseId),
        ]);
        await ensureUpdatesLoadedByRef(props.caseContext.singleCase.caseId);
        await ensureCaseLoaded(props.caseContext.singleCase.caseId);
    }, {
        onSuccess: () => {
            props.closeModal();
        },
        onError: (err) => {
            errorNotification(lang, err, 'any', lang.errorEntities.runTask);
        },
    });
    const updateType = updateTypesMap[node.data.updateTypeId];
    const executedUpdate = props.caseContext &&
        props.caseContext.updates.find((update) => update.state === UpdateState.Executed && update.taskId === node?.id);
    return (React.createElement(NodeEditorWithCaseContextPanel, null,
        React.createElement("h2", null, lang.updateTypes[updateType.updateTypeId] || updateType.label),
        executedUpdate ? (React.createElement(Button, { loading: rollbackMutation.isLoading, block: true, theme: "warning", onClick: () => rollbackMutation.mutate(executedUpdate.updateId) }, lang.workflows.rollbackTask)) : (React.createElement(Button, { loading: runTaskMutation.isLoading, block: true, onClick: () => runTaskMutation.mutate() }, lang.workflows.runTask))));
};
export default NodeEditorWithCaseContext;
const NodeEditorWithCaseContextPanel = styled(Panel) `
  position: absolute;
  width: 300px;
  z-index: 9;
  left: 40px;
  top: 80px;

  .body {
    max-height: calc(100vh - 340px);
    overflow-y: scroll;
  }
`;
//# sourceMappingURL=NodeEditorWithCaseContext.js.map